import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import allActions from '../../state/actions';
import Layout from '../../components/layout/Layout';
import PreloaderBg from '../../components/shared/preloaderBg/PreloaderBg';
import MenuLeft from '../../components/shared/menuLeft/MenuLeft';
import LenostreretiDetail from '../../components/lenostreretiDetail/LenostreretiDetail';

const Lenostrereti = () => {
	const location = useLocation();
	const dispatch = useDispatch();
	const currentPage = useSelector((state) => state.currentPage);
	const user = useSelector((state) => state.user);
	const staticPages = useSelector((state) => state.staticPages);
	const isFetching = currentPage.isFetching;

	useEffect(() => {
		// controllo nello store se ho già il dettaglio di lenostrereti, altrimenti eseguo action creator
		const lenostreretiPage = staticPages.lenostrereti;

		if (lenostreretiPage) {
			// setto i metatags
			document.title = lenostreretiPage.metaTitle;
			document.getElementsByTagName('META')[2].content =
				lenostreretiPage.metaDesc;
		}

		if (
			lenostreretiPage === undefined ||
			lenostreretiPage.detail === undefined
		) {
			// non ho i dati del prodotto nello store, chiamo action creator fetchLenostreretiDetail
			setTimeout(
				() =>
					dispatch(
						allActions.staticDetailActions.fetchLenostreretiDetail(
							currentPage.currentLang,
							user?.userData?.id
						)
					),
				50
			);
		} else {
			// loading...
			dispatch(allActions.isFetchingAction.loadStoredData());

			// recupero dati da store
			dispatch(
				allActions.staticDetailActions.loadLenostreretiDetail(lenostreretiPage)
			);
		}

		//console.log(lenostreretiPage);
	}, [location, staticPages]);

	return (
		<Layout>
			<div className='container mx-auto'>
				<PreloaderBg showPreloader={isFetching} />
				<div className='grid grid-cols-60'>
					<MenuLeft />
					<LenostreretiDetail />
				</div>
			</div>
		</Layout>
	);
};

export default Lenostrereti;
